let domain = "";

if (/bsms-(?!staging)\w+-kasse\.gomus\.de/.test(document.location.host)) {
  // special case for bsms, all POS go to single API endpoint
  domain = "bsms.gomus.de";
} else if (/antwerpen-(?!staging)\w+-kasse\.gomus\.be/.test(document.location.host)) {
  // special case for antwerpen, all POS go to single API endpoint
  domain = "antwerpen.gomus.be";
} else {
  // default behaviour strip -kasse, -integration and .demo.kasse
  domain = document.location.host.replace('.demo.kasse', '').replace('-kasse', '').replace('-integration', '');
}

export const environment = {
  production: true,
  domain: domain,
  shopDomain: document.location.host,
  environment: 'production',
  version: 'e7ac7b57',
  commit_sha: 'e7ac7b57cca1a58115a63f1830c557ad38d9af44',
  rollbarAccessToken: 'e8baa210d636404ca2e7cc5370391c9f',
};
